import { httpRequest } from '@calendly/http-tools'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const fetchUpcomingInvoice = createAsyncThunk(
  'upcomingInvoice/fetch',
  async (params, { rejectWithValue }) => {
    const [success, response] = await httpRequest({
      url: '/api/billing/subscription/invoices/new',
      method: 'GET',
      params
    })

    if (!success) {
      return rejectWithValue({
        isMinimumSeatError: response && response.payload && response.payload.key === 'billing.quantity.seat_minimum',
        isMaximumSeatError: response && response.payload && response.payload.key === 'billing.quantity.seat_maximum',
        errorMessage: response.message
      })
    }

    return response
  }
)
